var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-detail-header',{attrs:{"title":'Dashboard'}}),_vm._v(" "),_c('app-under-construction')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/paywall/partner/sections/PartnerMeterBlacklist.vue